import { render } from "./PrintTotalsBox.vue?vue&type=template&id=6bcad39c&scoped=true"
import script from "./PrintTotalsBox.vue?vue&type=script&lang=js"
export * from "./PrintTotalsBox.vue?vue&type=script&lang=js"

import "./PrintTotalsBox.vue?vue&type=style&index=0&id=6bcad39c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcad39c"]])

export default __exports__